import { WebBeanInfoProvider, type BeanInfoProvider, type PageLoader } from "./beanInfo";
import { LlmExtractor } from "./llm";
import { OpenGraphExtractor } from "./openGraph";
import { proxyPageLoader } from "./proxyLoader";
import { StructuredDataExtractor } from "./structuredData";

export * from "./beanInfo";
export { OpenGraphExtractor } from "./openGraph";
export { StructuredDataExtractor } from "./structuredData";
export { LlmExtractor } from "./llm";
export { proxyPageLoader, proxyConfigured, PROXY_URL } from "./proxyLoader";

/** The production stack: Open Graph → structured data → LLM, over the given loader. */
export function standardProvider(loader: PageLoader = proxyPageLoader()): BeanInfoProvider {
  return new WebBeanInfoProvider(loader, [new OpenGraphExtractor(), new StructuredDataExtractor(), new LlmExtractor()]);
}
